module.exports = __webpack_public_path__ + "media/soundtrack.3c55ff13.mp3";